export default __webpack_public_path__ + "static/media/rightArrow.bc0dbacf.svg";